/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import { cssMap, jsx } from '@compiled/react';

import Avatar from '@atlaskit/avatar';
import { fg } from '@atlaskit/platform-feature-flags';
import { Flex, Inline, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { useHubContext } from '@atlassian/company-hub-common';

const styles = cssMap({
	displayName: {
		font: token('font.body'),
	},
	root: {
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
	},
	emailText: {
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		width: '100%',
		display: 'inline-block',
		maxWidth: '160px',
	},
});

export const AccountDetails = (): JSX.Element => {
	const { user } = useHubContext();
	const { avatarSrc, displayName, email } = user;

	return (
		<div css={styles.root}>
			<Inline alignBlock="center" space="space.100">
				<Flex alignItems="center" justifyContent="center" gap="space.100">
					<Avatar appearance="circle" size="medium" src={avatarSrc} />
				</Flex>
				<Stack>
					<div css={styles.displayName}>{displayName}</div>
					{fg('csm_support_site_email_verification_updates') ? (
						<small css={styles.emailText}>{email}</small>
					) : (
						<small>{email}</small>
					)}
				</Stack>
			</Inline>
		</div>
	);
};
